var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading',{attrs:{"text":_vm.fields.address_heading}}),_vm._v(" "),_vm._l((_vm.fields.address_lines),function(item,index){return _c('p',{key:index,domProps:{"textContent":_vm._s(item.line)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }